export default function setupAxios(axios, store) {
  axios.defaults.withCredentials = true;
  // axios.interceptors.request.use(
  //   config => {

  //     const {
  //       auth: { isUserAuthenticated, accessToken }
  //     } = store.getState();

  //     if (isUserAuthenticated) {
  //       config.headers.Authorization = `Bearer ${accessToken}`;
  //     }
  //     return config;
  //   },
  //   err => Promise.reject(err)
  // );
};
